__turbopack_context__.v({
  "full_grid": "styles-module-scss-module__2lM_Pa__full_grid",
  "gallery_text": "styles-module-scss-module__2lM_Pa__gallery_text",
  "grid": "styles-module-scss-module__2lM_Pa__grid",
  "image_pagination": "styles-module-scss-module__2lM_Pa__image_pagination",
  "image_title": "styles-module-scss-module__2lM_Pa__image_title",
  "mobile_img": "styles-module-scss-module__2lM_Pa__mobile_img",
  "spinner": "styles-module-scss-module__2lM_Pa__spinner",
  "textbox": "styles-module-scss-module__2lM_Pa__textbox",
});
